import React from "react";
import ReactDOM from "react-dom";
import { StyledEngineProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";

import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material/styles";

import "./index.module.css";
import App from "./App";
import RootStore from "./store";

// let theme = createTheme();

var theme = createTheme({
  components: {
    // Name of the component
    MuiInputLabel: {
      styleOverrides: {
        // Name of the slot
        root: {
          margin: 0,
          padding: 0,
          fontSize: 13,
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

ReactDOM.render(
  <BrowserRouter>
    <RootStore>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </StyledEngineProvider>
    </RootStore>
  </BrowserRouter>,
  document.querySelector("#root")
);
